import styled, {keyframes} from 'styled-components';
import { Modal } from 'reactstrap';
import { fadeIn } from '@/shared'

const spinAround = keyframes`
  from {
    transform: rotate(0deg);
  } to {
    transform: rotate(360deg);
  }
`;

const StyledModal = styled(Modal)`
  .modal-content {
    border-radius: 0;

    .modal-body {
      padding: 1.5rem 1rem;

      @media only screen and (max-width: 550px) {
        font-size: .95rem;
      }
    }
  
    .modal-header {
      > h5 {
        font-weight: 600;
      }
  
      .close {
        outline: 0;
        margin: -0.75rem -1rem -1rem auto;
      }
    }
    
    .modal-footer {
      button {
        width: 7rem;
      }
    }
  }
`;
const StyledDeleteIconWrapper = styled.div`
  position: absolute;
  right: 0;
  margin-top: 5px;
  cursor: pointer;
`;

const StyledInlineErrorMessage = styled.div`
  font-size: 85%;
  color: #a80116;
  opacity: 0.75;
  filter: brightness(1.5);
  animation: ${fadeIn} .3s both ease-in-out;
`;

const LoadingIndicator = styled.div`
  position: relative;
  width: 20px;
  height: 20px;
  color: transparent !important;
  pointer-events: none;
  
  &:after {
    position: absolute !important;
    left: calc(50% - (1em / 2));
    top: calc(50% - (1em / 2));
    animation: ${spinAround} .5s infinite linear;
    border: 2px solid #fff;
    border-radius: 290486px;
    border-right-color: black;
    border-top-color: black;
    content: "";
    display: block;
    height: 1em;
    width: 1em;
    opacity: 1;
  }
`;

export {
  StyledModal,
  StyledInlineErrorMessage,
  StyledDeleteIconWrapper,
  LoadingIndicator
};
